module.exports = __webpack_public_path__ + "img/dirt-5.ae749671.png";